module.exports = require('./lib/chai');



/*****************
 ** WEBPACK FOOTER
 ** ./~/chai/index.js
 ** module id = 122
 ** module chunks = 1
 **/